import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { imagePropTypes } from '../../../propTypes';

import Picture from '../Picture';

const propTypes = {
  className: PropTypes.string,
  image: imagePropTypes.isRequired,
  reverse: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
};

const defaultProps = {
  className: '',
  reverse: false,
  text: '',
  title: '',
};

function SplitImage(props) {
  return (
    <div className="Component MediaSplit">
      <div className="MediaSplit_container">
        <div className="MediaSplit_body">
          <div
            className={classNames('MediaSplit_content', {
              'MediaSplit_content-reverse': props.reverse,
            })}
          >
            <div className="MediaSplit_text">
              <h3 className="MediaSplit_title">{props.title}</h3>
              <div className="MediaSplit_wysiwyg">{props.text}</div>
            </div>
            <div className="MediaSplit_media">
              {props.image && (
                <Picture
                  {...props.image}
                  sizes={[
                    [100, 1.77], // from 0
                    [100, 1.77], // from 440
                    [50, 1.77], // from 768
                    [50, 1.77], // from 1024
                    ['775', 1.77], // from 1440
                  ]}
                  className={props.className}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SplitImage.propTypes = propTypes;
SplitImage.defaultProps = defaultProps;

export default SplitImage;
